import { SUBSTANCE_CATEGORIES as C } from '../constants/effects';

// The three columns of the metals sort worksheet.
export const MATERIAL_GROUPS = Object.freeze({
  METAL: 'Metals',
  NON_METAL: 'Non-metals',
  METALLOID: 'Metalloids',
});

const NON_METAL_CATEGORIES = Object.freeze([C.NONMETAL, C.HALOGEN, C.NOBLE_GAS]);

export function getMaterialGroup(category) {
  if (category === C.METALLOID) return MATERIAL_GROUPS.METALLOID;
  if (NON_METAL_CATEGORIES.includes(category)) return MATERIAL_GROUPS.NON_METAL;
  return MATERIAL_GROUPS.METAL;
}

/**
 * { Metals: [element, ...], Non-metals: [...], Metalloids: [...] }, keeping the given order.
 */
export function sortIntoMaterialGroups(elements) {
  const groups = Object.fromEntries(Object.values(MATERIAL_GROUPS).map((group) => [group, []]));
  elements.forEach((element) => groups[getMaterialGroup(element.category)].push(element));
  return groups;
}

/**
 * The answer-key line for a "Fizz or no fizz?" pair, taken from what the lab shows.
 */
export function describeFizzResult(reaction) {
  if (!reaction.hasVisibleReaction()) return { fizzes: false, text: 'No fizz: nothing happens.' };
  return { fizzes: true, text: `Fizz! It makes ${reaction.productName.toLowerCase()}.` };
}
